import FormCard from '../../inputFormComponents/FormCard'
import FormRow from '../../inputFormComponents/FormRow'
import { TextInput, required, useTranslate } from 'react-admin'
import { bic, iban } from '../../validators/validate'
import DescriptionUserBankAccount from './descriptions/DescriptionUserBankAccount'

const UserBankAccountCard = () => {
  const translate = useTranslate()

  return (
    <FormCard title={translate('resources.bankAccount.name')} 
      description={<DescriptionUserBankAccount />}
      rows={[
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source='bankAccount.bankName' label={"resources.bankAccount.bankName"} validate={required()} />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source='bankAccount.accountOwner' label={"resources.bankAccount.accountOwner"} />
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source='bankAccount.iban' label={"resources.bankAccount.iban"} validate={[required(), iban()]} />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source='bankAccount.bic' label={"resources.bankAccount.bic"} validate={bic()} />
        ]} />
      ]}
    />
  )
}

export default UserBankAccountCard